export const ADD = 'add'
export const CLOSE = 'close'
export const ERROR = 'error'
export const SELECT = 'select'
export const SUBMIT = 'submit'
